import { combineReducers } from 'redux';

import * as types from 'modules/app/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import config from './config';
import hasError from './initialCalls/hasError';
import initCallsReady from './initialCalls/isReady';
import isNotificationCompatible from './isNotificationCompatible';
import isReady from './isReady';
import isStarted from './isStarted';
import location from './location';
import scrollTo from './scrollTo';

/**
 * @typedef {{
 *  config?: import('./config').AppConfigReducer,
 *  isReady: boolean,
 *  location : import("./location").AppLocationReducer,
 *  scrollTo: unknown,
 *  isStarted: boolean,
 *  initialCalls: { hasError: boolean, isReady: boolean },
 *  concurrency: { open: boolean },
 *  fuelTypes: import("modules/global/typing/vehicles/fuel-type.enum").FuelTypeEnum[],
 *  themes: string[],
 *  selfServiceWorkflow: import('modules/selfServices/types').Workflow
 * }} AppReducer
 */

export default combineReducers({
  config,
  isReady,
  location,
  scrollTo,
  isStarted,
  initialCalls: combineReducers({
    hasError,
    isReady: initCallsReady,
  }),
  healthCheck: createReducer(null, {
    [types.FETCH_HEALTH_CHECK_SUCCESS]: (_, { payload }) => payload,
    [types.FETCH_HEALTH_CHECK_FAILURE]: () => null,
  }),
  isNotificationCompatible,
  concurrency: combineReducers({
    open: createReducer(false, {
      [types.OPEN_CONCURRENCY_MODAL]: () => true,
      [types.CLOSE_CONCURRENCY_MODAL]: () => false,
    }),
  }),
  fuelTypes: createReducer([], {
    [types.FETCH_FUEL_TYPE_SUCCESS]: (_, { payload }) => payload,
  }),
  themes: createReducer([], {
    [types.FETCH_THEMES_SUCCESS]: (_, { payload = [] }) => payload
  }),
  selfServiceWorkflow: createReducer({}, {
    [types.FETCH_SELF_SERVICE_WORKFLOW_SUCCESS]: (_, { payload = {} }) => payload
  })
});
